module.exports = __webpack_public_path__ + "img/childrenChami .8385de5c.png";